import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M15.397 9C13.638 9 12.395 9.887 12.387 11.156C12.378 12.095 13.274 12.62 13.948 12.93C14.641 13.251 14.874 13.455 14.871 13.74C14.866 14.178 14.317 14.379 13.805 14.379C13.143 14.394 12.486 14.241 11.899 13.932L11.649 15.394C12.284 15.629 12.956 15.747 13.633 15.7441C15.505 15.7441 16.721 14.867 16.734 13.512C16.738 12.767 16.264 12.202 15.236 11.736C14.614 11.434 14.232 11.232 14.236 10.926C14.236 10.653 14.559 10.363 15.26 10.363C15.777 10.35 16.288 10.462 16.753 10.689L16.994 9.273C16.494 9.092 15.966 9 15.435 9C15.422 9 15.41 9 15.397 9ZM3.894 9.112H1.022L1 9.249C1.652 9.403 2.282 9.644 2.871 9.967L4.454 15.642H6.339L9.142 9.12L7.257 9.117L5.511 13.573L5.326 12.667L4.702 9.665C4.615 9.333 4.316 9.107 3.981 9.107C3.952 9.107 3.923 9.109 3.894 9.112ZM19.248 9.66L16.604 15.646H18.474C18.474 15.646 18.779 14.841 18.849 14.665H21.13C21.182 14.894 21.347 15.644 21.347 15.644H22.999L21.558 9.118H20.182C20.144 9.113 20.106 9.111 20.069 9.111C19.713 9.111 19.387 9.324 19.248 9.66ZM20.307 10.88C20.548 12.006 20.314 10.913 20.84 13.33H19.362C19.435 13.142 20.163 11.275 20.307 10.88ZM9.863 9.112L8.75 15.646H10.531L11.645 9.112H9.863Z',
                    fill: '#2FABFF',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const VisaLogoColored = React.forwardRef(IconComponent);
VisaLogoColored.displayName = 'VisaLogoColored';

export { VisaLogoColored };
